import React, { useEffect, useState } from 'react';
import liracrypt from '../../components/Liracrypt/liracrypt';
import ApiErrorComp from '../../components/ApiErrorComp/ApiErrorComp';
import { Card, Form, Select, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import MainLineGroupDashboard from './MainLineGroupDashboard';

const LineGroupDashboard = () => {
    const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
    const [selectedGroupId, setSelectedGroupId] = useState("");
    const [loadLineAccess, setLoadLineAccess] = useState(null);
    const [loginError, setLoginError] = useState(false);



    const fetchLineAccess = () => {
        liracrypt
            .get("/multilinedashboard/linegroup", {})
            .then(({ data }) => {

                if (data.data.length === 1) {
                    setSelectedGroupId(data.data[0]["_id"]);
                } else {
                    setLoadLineAccess(data.data);
                }
            })
            .catch(function (error) {
                console.log("fetchLineAccess Error****:", error);
                if (error.response !== undefined) {
                    if (error.response.status !== 401) {
                        ApiErrorComp(error.response.status);
                    } else {
                        setLoginError(true);
                    }
                }
            });
    };


    useEffect(() => {
        fetchLineAccess();
    }, []);


    const selectLid = ( !selectedGroupId &&
        <div className="dash">
            <Card
                title={
                    <span style={{ fontWeight: 600 }}>Please select line group</span>
                }
                bordered={false}
                style={{
                    width: "600px",
                    margin: "10% auto",
                    backgroundColor: "#424358",
                    border: 0,
                    boxShadow: "5px 5px 10px #1f1f1f, -5px -5px 10px #2d2d2d",
                    borderRadius: "10px",
                    fontWeight: "600",
                    padding: "10px",
                }}
            >
                {loadLineAccess ? (
                    <Form.Item
                        className="selectLine"
                        rules={[{ required: true, message: "Select line group" }]}
                    >
                        <Select
                            showSearch
                            style={{ width: 200 }}
                            placeholder="Select line group"
                            optionFilterProp="children"
                            onChange={(value) => {
                                setSelectedGroupId(value);
                            }}
                            filterOption={(input, option) =>
                                option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {loadLineAccess.map((obj) => (
                                <Select.Option value={obj._id}>{obj.name}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                ) : (
                    <div className="Loading">
                        <Spin indicator={antIcon} />
                    </div>
                )}
            </Card>
        </div>
    )

    return (
        <div className='line-dashboard-zen'>
            {selectLid}
            {
                selectedGroupId && (
                    <MainLineGroupDashboard selectedGroupId={selectedGroupId} setSelectedGroupId={setSelectedGroupId} />
                )
            }
        </div>
    )
};

export default LineGroupDashboard;